import React, { useEffect, useState } from 'react';
import { Card, CardBody, Button, Table } from 'reactstrap';
import LoaderButton from '../loader-button/LoaderButton';
import { toast } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import FalconCardHeader from '../common/FalconCardHeader';
import Heading from '../common/Heading';
import Loader from '../common/Loader';
import InputGroupModal from '../common/InputGroupModal';
import ConfirmModal from '../common/ConfirmModal';

// services
import BZAPIService from '../../services/BZAPIService';
//libs
import { adminIsReadOnlyCheck } from '../../helpers/rbac';
// constants
const newGroup = { name: '' };

const ViewGroups = () => {
  const [rbacGroups, setRbacGroups] = useState([]);
  const [isReadOnly, setIsReadOnly] = useState(true);
  const [showAlert, setShowAlert] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [loader, setLoader] = useState(false);
  const [selectedGroup, setSelectedGroup] = useState(newGroup);
  const [roles, setRoles] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [groupRbacRoles, setGroupRbacRoles] = useState([]);

  useEffect(() => {
    async function onLoad() {
      try {
        setIsLoading(true);
        const apiRbacRolesPromise = BZAPIService.getRbacRoles() || {};
        const groupsPromise = BZAPIService.listRbacGroups();
        const myUserPermissionsPromise = BZAPIService.getMyUserPermissions();
        const [apiRbacRoles, groups, myUserPermissions] = await Promise.all([
          apiRbacRolesPromise,
          groupsPromise,
          myUserPermissionsPromise
        ]);
        console.log('myUserPermissions', myUserPermissions, adminIsReadOnlyCheck(myUserPermissions));
        setRoles(apiRbacRoles);
        setIsReadOnly(adminIsReadOnlyCheck(myUserPermissions));
        setIsLoading(false);
        setRbacGroups(groups ? groups : []);
      } catch (e) {
        setIsLoading(false);
      }
    }
    onLoad();
  }, []);
  const handleEditGroup = async group => {
    setIsSubmitted(true);
    try {
      setLoader(true);
      setSelectedGroup(group);
      // Edit Group
      // const apiRbacRolesPromise = BZAPIService.getRbacRoles() || {};
      const apiGroupRbacRoles = (await BZAPIService.getGroupRbacRoles(group.id)) || {};
      console.log('apiGroupRbacRoles', apiGroupRbacRoles);
      // setRoles(apiRbacRoles);
      setGroupRbacRoles(apiGroupRbacRoles);
      setModalOpen(true);
      setLoader(false);
    } catch (e) {
      setLoader(false);
      toast.error('Failed to load role');
    }
  };
  const handleDeleteGroup = async groupId => {
    setLoader(true);

    try {
      // Create new Open API Role
      await BZAPIService.deleteRbacGroup(groupId);
      toast.success('Group deleted');
      const apiRbacGroups = (await BZAPIService.getRbacGroups()) || {};
      setRbacGroups(apiRbacGroups ? apiRbacGroups : []);
      setLoader(false);
      setShowAlert(false);
    } catch (e) {
      console.log('e', e);
      setLoader(false);
      setShowAlert(false);
      toast.error('Failed to load role');
    }
  };

  const handleCreateGroup = async () => {
    setIsSubmitted(true);
    try {
      setLoader(true);
      // Create new Open API Role
      setSelectedGroup({ ...newGroup });
      setModalOpen(true);
      setLoader(false);
    } catch (e) {
      console.log('e', e);
      setLoader(false);
      toast.error('Failed to load role');
    }
  };
  const handleConfirmDelete = async group => {
    // const apiRbacRole = (await BZAPIService.getRbacRole(groupId)) || {};
    setSelectedGroup(group);
    setShowAlert(true);
  };
  const handleDelete = async groupId => {
    setLoader(true);

    try {
      // Create new Open API Role
      await BZAPIService.deleteRbacGroup(groupId);
      toast.success('Group deleted');
      const apiRbacGroups = (await BZAPIService.listRbacGroups()) || {};
      setRbacGroups(apiRbacGroups ? apiRbacGroups : []);
      setLoader(false);
      setShowAlert(false);
    } catch (e) {
      console.log('e', e);
      setLoader(false);
      setShowAlert(false);
      toast.error('Failed to load role');
    }
  };

  const updateGroup = async payload => {
    setIsSubmitted(true);
    try {
      setLoader(true);
      // Create new Open API Group
      await BZAPIService.updateRbacGroup(payload);
      toast.success('Group updated');
      const apiRbacGroups = (await BZAPIService.listRbacGroups()) || {};
      setRbacGroups(apiRbacGroups ? apiRbacGroups : []);

      setLoader(false);
      setModalOpen(false);
    } catch (e) {
      setLoader(false);
      toast.error('Failed to update role');
    }
  };

  if (isLoading && !isSubmitted) return <Loader />;
  return (
    <>
      <Heading
        title="BugZero groups"
        subtitle="View groups within your organization"
        className="mb-4 mt-3"
        icon="users"
      />

      <Card>
        <CardBody className="fs--1">
          <div />
          <Table bordered striped style={{ marginTop: '20px' }}>
            <thead className="card-header">
              <tr>
                <th>Name</th>
                <th className="col-2">Actions</th>
              </tr>
            </thead>
            <tbody>
              {rbacGroups?.length ? (
                rbacGroups.map(group => {
                  // Email
                  const { id, name } = group;
                  return (
                    <tr key={id} id={id} className="font-weight-bold" data-testid={'group-row'}>
                      <td>
                        <div className="py-2">{name}</div>
                      </td>

                      <td>
                        <>
                          <LoaderButton
                            isLoading={selectedGroup?.id === id && loader}
                            onClick={e => handleEditGroup(group)}
                            value={name}
                            name={group.id}
                            size="sm"
                            color="falcon-primary"
                            data-testid={'group-delete-alert'}
                          >
                            <FontAwesomeIcon icon={'edit'} value={name} />
                          </LoaderButton>
                          {'   '}
                          <Button
                            onClick={e => handleConfirmDelete(group)}
                            value={group.id}
                            disabled={isReadOnly}
                            name={group.name}
                            color="falcon-danger"
                            data-testid={'role-delete-alert'}
                          >
                            <FontAwesomeIcon icon={'trash'} color={'#bd472a'} value={group.id} />
                          </Button>
                        </>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr className="font-weight-bold">
                  <td>You have no groups yet</td>
                  <td />
                </tr>
              )}

              <tr />
            </tbody>
          </Table>
          <div className="text-right">
            <Button
              color="falcon-primary"
              className="btn-sm"
              disabled={isReadOnly}
              onClick={handleCreateGroup}
              data-testid={'input-modal-cta'}
            >
              Create Group
            </Button>
            {/*
        <InputGroupModal
          isReadOnly={isReadOnly}
          selectedGroup={selectedGroup}
          setSelectedGroup={setSelectedGroup}
          isSubmitted={isSubmitted}
          setIsSubmitted={setIsSubmitted}
          modalOpen={modalOpen}
          setModalOpen={setModalOpen}
          setIsLoading={setIsLoading}
          createGroup={createGroup}
          updateGroup={updateGroup}
          loader={loader}
        />
        <ConfirmModal
          name={selectedGroup.name}
          value={selectedGroup.id}
          confirmCallback={handleDeleteGroup}
          showAlert={showAlert}
          setShowAlert={setShowAlert}
          loader={loader}
        /> */}
            <ConfirmModal
              name={selectedGroup.name}
              value={selectedGroup.id}
              confirmCallback={handleDelete}
              showAlert={showAlert}
              setShowAlert={setShowAlert}
              loader={loader}
            />
          </div>
        </CardBody>
      </Card>
      {!!selectedGroup && (
        <InputGroupModal
          isReadOnly={isReadOnly}
          rbacGroups={rbacGroups}
          selectedGroup={selectedGroup}
          isSubmitted={isSubmitted}
          setIsSubmitted={setIsSubmitted}
          modalOpen={modalOpen}
          roles={roles}
          setModalOpen={setModalOpen}
          setIsLoading={setIsLoading}
          groupRbacRoles={groupRbacRoles}
          updateGroup={updateGroup}
          loader={loader}
        />
      )}
    </>
  );
};

export default ViewGroups;
